export default "__VITE_ASSET__BI7DyK2k__"